export const HEADERS = [
  'HEADER.ID',
  'HEADER.NAME',
  'HEADER.CODE',
  'HEADER.CREATED',
];
